export default __webpack_public_path__ + "076698de1cc8683115363fc42f94b6e6.png";